<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "RasioIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
